import React from 'react';
import {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class MorningOpenPlayers extends React.Component {
  label = () => {
    return "Участники";
  }

  message = () => {
    return "Никто из участников пока не подтвердил участие";
  }

  players = () => {
    return (
      <PlayersInner
        label={this.label()}
        message={this.message()}
        players={this.props.game.playersWithPayment}
        totalPlayersNum={this.props.game.totalPlayersWithPaymentNum}
        numberOfPlayers={this.props.game.numberOfPlayers}
        playersCount={true}
        flag={""}
      />
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default MorningOpenPlayers;
